// extracted by mini-css-extract-plugin
export default {"cardBody":"c-f_cW"};